import React, { useState, useEffect } from "react";
import { Outlet, Link } from "react-router-dom";
import { useSelector } from 'react-redux';
import conalepBlanco from "./../assets/images/escudos/conalepBlanco.png";
import colibriHorizontal from "./../assets/images/escudos/Colibri_Horizontal_FondoOscuro.png";
import escudoEdomex from "./../assets/images/escudos/ESCUDO EDOMEX_Horizontal_FondoOscuro.png";

import { Layout, Menu, Grid, Image, Flex, Row, Card, Avatar, Tooltip, Col } from "antd";

import * as ALLICONS from '@ant-design/icons';

const KEY_MENU_CLOSE_MENU = "logout";

const close_session = [{
    key: KEY_MENU_CLOSE_MENU,
    label: "Cerrar Sesión",
    icon: "PoweroffOutlined",
    path: "/",
}]



const { Header, Content, Footer, Sider } = Layout;

export default function Dashboard(props) {

    const { useBreakpoint } = Grid;
    const screens = useBreakpoint();
    const [collapsed, setCollapsed] = useState(false);
    const userDataSlice = useSelector(store => store.userDataSlice);
    const { LogOut } = props;
    const userProfile = useSelector(store => store.permissionsSlice);
    const menuItems = generateMenuItems([...userProfile.menu, ...close_session], LogOut);

    useEffect(() => {
        if (screens.xs) {
            setCollapsed(true);
        } else {
            setCollapsed(false);
        }
    }, [screens]);

    return (
        <Layout style={{ minHeight: "100vh" }}  >
            <Header>
                <Flex justify="center">
                    <Image
                        preview={false}
                        src={escudoEdomex}
                        alt="logotipo Conalep"
                        width={"90px"}
                        style={{ minWidth: "90px" }}
                    />
                    <Image
                        preview={false}
                        src={colibriHorizontal}
                        alt="logotipo Conalep"
                        width={"90px"}
                        style={{ minWidth: "90px" }}
                    />
                    <Image
                        preview={false}
                        src={conalepBlanco}
                        alt="logotipo Conalep"
                        width={"100px"}
                        style={{ minWidth: "90px" }}
                    />
                </Flex>
            </Header>
            <Layout>
                <Sider collapsible collapsed={collapsed} onCollapse={setCollapsed}>
                    <Row justify="center">
                        <Col>
                            <Link to="/profile">
                                <Card
                                    size="small"
                                    style={{ textAlign: "center" }}
                                >
                                    <Tooltip title={userDataSlice?.user}>
                                        <Avatar
                                            size={(screens.lg || screens.xl || screens.xxl) ? 64 : 40}
                                            icon={<ALLICONS.UserOutlined />}
                                        />
                                    </Tooltip>
                                    {
                                        ((screens.sm || screens.lg || screens.xl || screens.xxl) && !collapsed) && <>
                                            <h4>{userDataSlice?.user}</h4>
                                            {userDataSlice?.rol && userDataSlice?.rol?.map((rol, index) => (
                                                <h4 key={index}>{rol}</h4>
                                            ))} </>

                                    }

                                </Card>
                            </Link>
                        </Col>
                        <Col>
                            <Menu
                                mode="inline"
                                items={menuItems}

                            />
                        </Col>
                    </Row>
                </Sider>
                <Layout>
                    <Content>
                        <div className="layoutDashboard-container ">
                            <Outlet />
                        </div>
                    </Content>
                    {screens.sm &&
                        <Footer style={{ textAlign: "center" }}>
                            <b> Copyright  ©{new Date().getFullYear()} CONALEP Estado de México. </b> Todos los derechos son reservados.
                        </Footer>}
                </Layout>
            </Layout>
        </Layout>
    );
};
const generateMenuItems = (menuArray, LogOut) => {
    return menuArray.map(item => {
        const updatedItem = { ...item };

        updatedItem.label = <Tooltip placement="rightTop" title={updatedItem.label}>{updatedItem.label}</Tooltip>;

        // Si tiene 'path', envolver el label con un Link
        if (updatedItem.path) {
            updatedItem.label = updatedItem.key !== KEY_MENU_CLOSE_MENU
                ? <Tooltip placement="right" title={updatedItem.label}><Link to={updatedItem.path}>{updatedItem.label}</Link></Tooltip>
                : <Tooltip placement="right" title={updatedItem.label}><Link onClick={LogOut}>{updatedItem.label}</Link></Tooltip>;
        } else {
            delete updatedItem.path; // Eliminar si no tiene 'path'
        }

        // Transformar icono si existe
        if (updatedItem.icon) {
            updatedItem.icon = getAntIconComponent(updatedItem.icon);
        }

        // Recursividad para hijos no vacíos
        if (updatedItem.children?.length) {
            updatedItem.children = generateMenuItems(updatedItem.children, LogOut);
        } else {
            delete updatedItem.children; // Eliminar si no tiene hijos
        }

        return updatedItem;
    });
}


const getAntIconComponent = (iconName) => {
    const IconComponent = ALLICONS[iconName];
    return IconComponent ? <IconComponent /> : null;
};